<div class="w-full flex flex-column align-items-center justify-content-center" style="height: 70vh;" *ngIf="isLoading">
    <p-progressSpinner></p-progressSpinner>
    <div>{{ 'sipo.file-is-loading' | translate }}</div>
</div>

<div class="text-5xl text-red-500 flex align-items-center justify-content-center" style="height: 70vh;"
     *ngIf="pdfFileUploadingProcessTrack === 'error'">
    {{ 'sipo.file-uploading-failed' | translate }}
</div>

<div class="droppable">
    <div class="pdf-container">
        <div *ngIf="pdfDto?.images?.length">
            <div class="pdf-document">
                <!-- J E D E  S E I T E  B E K O M M T  E I G E N E N  C O N T A I N E R -->
                <div *ngFor="let image of pdfDto.images"
                     class="pdf-page"
                     [attr.data-page-number]="image.pageNumber">
                    <img [src]="'data:image/png;base64,' + image.data"
                         class="image-content border-2 pdf-page-img"
                         alt="PDF page">
                </div>
            </div>
        </div>
    </div>

    <div #droppableContainerRef class="drag-items flex pl-4 flex-column align-items-center">
        <div class="font-semibold text-center font-bold pb-1 border-bottom-1 fixed" style="right: 50px; width: 15%;" *ngIf="!isLoading">
            {{ 'sipo.signing-drag-drop-header' | translate }}
        </div>
    </div>
</div>
